import { ProcessorJobStatus, StatusVariant } from '@consigli/types';

export const processorJobStatusMapping = {
  [ProcessorJobStatus.INITIALIZED]: { text: 'Initialized', variant: StatusVariant.INFO },
  [ProcessorJobStatus.STARTED]: { text: 'Started', variant: StatusVariant.INFO },
  [ProcessorJobStatus.FAILED]: { text: 'Failed', variant: StatusVariant.ERROR },
  [ProcessorJobStatus.COMPLETED]: { text: 'Completed', variant: StatusVariant.SUCCESS },
  [ProcessorJobStatus.STOPPED]: { text: 'Stopped', variant: StatusVariant.WARNING },
} as const;
